import { render, staticRenderFns } from "./InitialDiagnosis.vue?vue&type=template&id=4652a94e&scoped=true"
import script from "./InitialDiagnosis.vue?vue&type=script&lang=js"
export * from "./InitialDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./InitialDiagnosis.vue?vue&type=style&index=0&id=4652a94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652a94e",
  null
  
)

export default component.exports